import { useEffect, useState } from "react";
import { Alert, Collapse } from "@mui/material";

interface PersonaNotFoundNoticeProps {
  /** `personaNotFound` from useResolvePersona: the URL slug answered 404. */
  personaNotFound: boolean;
  /** Drops `?persona=` so the notice does not return on every render. */
  clearUrlPersona: () => void;
}

/**
 * Dismissible notice for a `?persona=` link to an agent the user cannot see
 * (removed, or private and not shared with them), shown instead of quietly
 * starting a generic chat.
 */
const PersonaNotFoundNotice = ({
  personaNotFound,
  clearUrlPersona,
}: PersonaNotFoundNoticeProps) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (personaNotFound) {
      setOpen(true);
      clearUrlPersona();
    }
    // clearUrlPersona is redeclared per render; the 404 is what matters.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personaNotFound]);

  return (
    <Collapse in={open} unmountOnExit>
      <Alert
        severity="warning"
        onClose={() => setOpen(false)}
        sx={{ mb: 3 }}
        data-testid="aa-persona-not-found"
      >
        This agent isn&apos;t available. It may have been removed, or you may
        not have access.
      </Alert>
    </Collapse>
  );
};

export default PersonaNotFoundNotice;
